import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight, ChevronDown } from "lucide-react";
import { SOLUTIONS } from "@/data/content";
import { Icon } from "@/components/shared/Icon";

export const SolutionsMenu = ({ linkClass }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="relative" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <NavLink to="/solutions" data-testid="nav-link-solutions" className={linkClass} aria-haspopup="true" aria-expanded={open}>
        {({ isActive }) => (
          <span className="inline-flex items-center gap-1">
            Solutions <ChevronDown className={`h-3.5 w-3.5 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
            {isActive && <motion.span layoutId="nav-dot" className="absolute -bottom-0.5 left-1/2 h-1 w-1 -translate-x-1/2 rounded-full bg-cyan-400" />}
          </span>
        )}
      </NavLink>
      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="nav-solutions-menu"
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 8 }}
            transition={{ duration: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className="absolute left-1/2 top-full z-50 w-[720px] -translate-x-1/2 pt-4"
          >
            <div className="rounded-2xl border border-line bg-navy/95 p-3 shadow-[0_40px_80px_-30px_rgba(0,0,0,0.9)] backdrop-blur-xl">
              <div className="grid grid-cols-2 gap-1">
                {SOLUTIONS.map((s) => (
                  <Link
                    key={s.slug}
                    to={`/solutions/${s.slug}`}
                    data-testid={`nav-solution-${s.slug}`}
                    onClick={() => setOpen(false)}
                    className="group flex items-start gap-3 rounded-xl p-3 transition-colors hover:bg-white/[0.05]"
                  >
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-line bg-navy-800 text-cyan-400 transition-colors group-hover:border-cyan-400/50">
                      <Icon name={s.icon} className="h-4 w-4" />
                    </span>
                    <span className="min-w-0">
                      <span className="block text-sm font-semibold text-white">{s.title}</span>
                      <span className="mt-0.5 block text-xs leading-relaxed text-slate-400 line-clamp-1">{s.tagline}</span>
                    </span>
                  </Link>
                ))}
              </div>
              <Link to="/solutions" onClick={() => setOpen(false)} data-testid="nav-solutions-all" className="mt-2 flex items-center justify-between rounded-xl border border-line bg-navy-800/60 px-4 py-3 text-sm font-medium text-slate-200 transition-colors hover:text-cyan-400">
                View all solutions <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
